module.exports = __webpack_public_path__ + "static/banner-13-a476e640b9698fd8e8fabe79a77cc9d6.jpg";